class ComponentSearchInput extends HTMLElement {
  connectedCallback() {
    // Find the input provided in the HTML (light DOM)
    this._input =
      this.querySelector('[data-component-search-input]') ||
      this.querySelector('input[type="search"], input[type="text"]');

    if (!this._input) return;

    // What to filter inside this component
    this._itemsSelector = this.getAttribute('item-selector') || '[data-search-item]';

    // Bind once
    this._onInput = this._onInput.bind(this);
    this._onSlotChange = this._onSlotChange.bind(this);

    // Listen
    this._input.addEventListener('input', this._onInput);

    // If content changes dynamically (facet redraw), re-cache items
    this._observer = new MutationObserver(this._onSlotChange);
    this._observer.observe(this, { childList: true, subtree: true });

    // Initial run
    this._cacheItems();
    this._onInput();
  }

  disconnectedCallback() {
    if (this._input && this._onInput) this._input.removeEventListener('input', this._onInput);
    if (this._observer) this._observer.disconnect();
  }

  _normalize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  _cacheItems() {
    this._items = Array.from(this.querySelectorAll(this._itemsSelector));

    // Fallback, in case selector is customized incorrectly
    if (!this._items.length) {
      this._items = Array.from(this.querySelectorAll('[data-search-item]'));
    }
  }

  _onSlotChange() {
    // DOM changed; re-cache and re-filter
    this._cacheItems();
    this._onInput();
  }

  _onInput() {
    if (!this._items) this._cacheItems();

    const query = this._normalize(this._input.value);
    const tokens = query ? query.split(/\s+/).filter(Boolean) : [];

    // Show all when empty
    if (!tokens.length) {
      this._items.forEach((el) => {
        el.hidden = false;
        el.removeAttribute('aria-hidden');
      });
      return;
    }

    this._items.forEach((el) => {
      const text = this._normalize(el.textContent);
      const match = tokens.every((t) => text.includes(t));

      el.hidden = !match;
      if (!match) el.setAttribute('aria-hidden', 'true');
      else el.removeAttribute('aria-hidden');
    });
  }
}

if (!customElements.get('component-search-input')) {
  customElements.define('component-search-input', ComponentSearchInput);
}